export const COVERAGE_AVAILABLE = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Product',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Insurance Name',
  },
  {
    value: '',
    label: 'Physician',
  },
  {
    value: '',
    label: ' Medical Coverage (Buy & Bill)',
  },
  {
    value: '',
    label: 'Pharmacy Coverage (Specialty Pharmacy)',
  },
  //  {
  //   value: '',
  //   label: 'Copay Status',
  // },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value : '',
    label: 'AM/FRM Note'
  }
];
export const COVERAGE_MANUFACTURE_AVAILABLE = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Case type',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Physician',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'Patient Activation Status',
  },
  {
    value: '',
    label: 'Indiction',
  },
  {
    value: '',
    label: 'Confirm Indiction',
  },
  {
    value: '',
    label: 'KAM/FAM Note',
  },
  
 
];
export const ACTION_REQUIRED = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Product',
  },
  // {
  //   value: '',
  //   label: 'Case Type',
  // },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Insurance Type',
  },
  {
    value: '',
    label: 'Physician',
  },
  {
    value: '',
    label: 'Medical Coverage (Buy & Bill)',
  },
  // {
  //   value: '',
  //   label: ' Next Step',
  // },
  {
    value: '',
    label: 'Pharmacy Coverage (Specialty Pharmacy)',
  },
  
  {
    value: '',
    label: ' Next Step',
  },
  // {
  //   value: '',
  //   label: 'Next Steps',
  // },
]
export const ACTION_MANUFACTURE_REQUIRED = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Case type',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Physician',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
  },
  {
    value: '',
    label: 'Next Steps',
  },
  {
    value: '',
    label: 'Patient Activation Status',
  },
  {
    value: '',
    label: 'Indiction',
  },
  {
    value: '',
    label: 'Confirm Indiction',
  },
  {
    value: '',
    label: 'KAM/FAM Note',
  },
  
]
export const SPECIALITY_PHARMACY = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value:'',
    label:'Product'
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Pharmacy (SP) Status',
  },
  //  {
  //   value: '',
  //   label: 'Copay Status',
  // },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'SP Transferred to',
  },
  {
    value: '',
    label: 'Date Transferred',
  },
  {
    value: '',
    label: 'Status Update',
  },
  {
    value: '',
    label: 'Date Shipped',
  },
  // {
  //   value: '',
  //   label: 'Carrier',
  // },
  // {
  //   value: '',
  //   label: 'Tracking Number',
  // },
  
]
export const PENDING_TABLE = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value:'',
    label:'Product'
  },
  // 
  {
    value: '',
    label: 'BI Submitted',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Primary Insurance Type',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: ' Medical Coverage (Buy & Bill)',
  },
  // {
  //   value: '',
  //   label: ' Next Step',
  // }, 
  {
    value: '',
    label: 'Pharmacy Coverage (Specialty Pharmacy)',
  },
  //  {
  //   value: '',
  //   label: 'Copay Status',
  // },
  {
    value: '',
    label: ' Next Step',
  },
  
];
export const COPAY_TABLE = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value:'',
    label:'Product'
  },
  // 
  {
    value: '',
    label: 'BI Submitted',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Primary Insurance Type',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: ' Medical Coverage (Buy & Bill)',
  },
  // {
  //   value: '',
  //   label: ' Next Step',
  // }, 
  {
    value: '',
    label: 'Pharmacy Coverage (Specialty Pharmacy)',
  },
   {
    value: '',
    label: 'Copay Status',
  },
  {
    value: '',
    label: ' Next Step',
  },
  
];
export const SPECIALITY_MANUFACTURE_PHARMACY = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Provider',
  },
  
  {
    value: '',
    label: 'SP Transferred To',
  },
  {
    value: '',
    label: 'Date Transferred',
  },
  {
    value: '',
    label: 'Status Update',
  },
  {
    value: '',
    label: 'Date Shipped',
  },
  {
    value: '',
    label: 'Carrier',
  },
  {
    value: '',
    label: 'Tracking Number',
  },
  {
    value: '',
    label: 'Pharmacy (SP) Status',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'Indiction',
  },
  // {
  //   value: '',
  //   label: 'Confirm Indiction',
  // },
  {
    value: '',
    label: 'KAM/FAM Note',
  },
]


export const PENDING_MANUFACTURE_TABLE = [
  {
    value: '',
    label: 'Patient Name',
  },
  {
    value: '',
    label: 'Patient ID',
  },
  {
    value: '',
    label: 'BI Case ID',
  },
  {
    value: '',
    label: 'Case Type	',
  },
  {
    value: '',
    label: 'BI Submitted',
  },
  {
    value: '',
    label: 'BI Completed',
  },
  {
    value: '',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
  },
  {
    value: '',
    label: 'Provide Treatment Status',
  },
  {
    value: '',
    label: 'Indiction',
  },
  {
    value: '',
    label: 'Confirm Indiction',
  },
  {
    value: '',
    label: 'KAM/FAM Note',
  },
];
